// extracted by mini-css-extract-plugin
export default {"wrap":"co-z","logoContainer":"do-z","brandImg":"eo-z","logoImg":"fo-z","logoButton":"go-z"};